<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <div class="col-xl-12" v-show="data.itens.length == 0 && data.loaded">
                            <div class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>                            
                        </div>                          
                        <div class="col-xl-12" v-show="data.itens.length > 0 && data.loaded">
                            <div v-for="(item, index) in data.itens" class="margin-bottom-25">
                                <h4 class="margin-bottom-10">
                                    <span class="dashboard-status-button green margin-right-10" style="color: #fff !important;">
                                        <i class="material-icons" style="color: #fff;">star</i>
                                        <b>{{item.nota}}</b>
                                    </span>
                                    <i class="material-icons">store</i>
                                    <b>{{item.nome}}</b>
                                </h4>   
                                <div class="row">
                                    <div class="col-lg-12">

                                        <h5 v-show="item.itens.length == 0">
                                            Nenhuma avaliação recebida.
                                        </h5>

                                        <div class="table-scroll" style="overflow-x: scroll;" v-show="item.itens.length > 0">

                                            <table class="table table-bordered table-bordered-default table-responsive">
                                                <thead>
                                                    <th style="min-width: 1px; width: 1px;">
                                                        ID
                                                    </th>
                                                    <th style="min-width: 200px; width: 200px">
                                                        Piloto
                                                    </th>
                                                    <th style="min-width: 200px; width: 200px;">
                                                        Abastecedor
                                                    </th>                                         
                                                    <th style="min-width: 30px; width: 30px;">
                                                        Nota
                                                    </th>
                                                    <th style="min-width: 280px;">
                                                        Comentário
                                                    </th>                                                    
                                                    <th style="min-width: 140px; width: 140px;">
                                                        Avaliado em
                                                    </th>                                                           
                                                </thead>
                                                <tbody>   

                                                    <tr v-for="item2 in item.itens">
                                                        <td data-label="ID">
                                                            {{item2.id}}
                                                        </td>
                                                        <td data-label="Piloto">
                                                            {{item2.contratante.nome}}
                                                        </td>                                         
                                                        <td data-label="Abastecedor">
                                                            {{item2.prestador.nome}}
                                                        </td>
                                                        <td data-label="Nota">    
                                                            {{item2.nota}}
                                                        </td>
                                                        <td data-label="Comentário">    
                                                            {{item2.texto}}
                                                        </td>                                                                                          
                                                        <td data-label="Avaliado em">
                                                            {{item2.datahora | formatDate}}
                                                        </td>                                                                                                                               
                                                    </tr>
                                                </tbody>
                                            </table>
                                        
                                        </div>
                                    </div>
                                </div>   
                                <br><hr style="opacity: 0.2;">                                                         
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Arquivos',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token
            },
        }
    },
    watch: {
                  
    },
    methods: {          
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/avaliacoes.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });                 
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },             
        get: function() {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "avaliacoes",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/avaliacoes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },
        init: function() {
            var self = this;
            Promise.all([
                self.get()
            ]).then(function() {
            
                self.$forceUpdate();
                loading.hide();
                
            }).catch(function(error) {
                loading.hide();
            });            
        }
    },
    created: function() {
        var self = this;

        loading.show();
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }          

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/Avaliacoes.vue